import React from 'react';
import './App.css';
import styled from 'styled-components';
import Assessment from './pages/assessment';

const AppLayout = styled.div`
  overflow: scroll;
  max-width: 400px;
  min-width: 300px;
  margin-left:auto;
  margin-right:auto;
  height: 100%;
  padding: 10px 30px;
  background: linear-gradient(180deg, #2B5740 25%, #E5E5E5 0%);
`
function App() {
  return (
    <AppLayout className="App">
      <Assessment />
    </AppLayout>
  );
}

export default App;
